import type { ReportColumnLayout } from '../types';
import type { CSSProperties } from 'react';

export const getColumnLayoutStyles = (
  columnLayout: ReportColumnLayout,
  hasTooltipCard?: boolean,
) => {
  return {
    '--column-cell-min-width': columnLayout.minWidth,
    '--column-cell-max-width': columnLayout.maxWidth,
    '--column-cell-justify-content': columnLayout.align,
    '--column-cell-padding-inline': columnLayout.paddingInline,
    '--column-first-padding-inline': columnLayout.columnFirstPaddingInline,
    '--column-wrapper-width': columnLayout.columnWrapperWidth,
    '--column-cell-padding-right': !hasTooltipCard
      ? columnLayout.paddingRight
      : columnLayout.paddingInline,
    '--column-header-cell-padding-right': !hasTooltipCard
      ? columnLayout.headerPaddingRight
      : columnLayout.paddingInline,
    '--column-dimension-box-shadow': columnLayout.dimensionBoxShadow,
    '--column-border-right-width': columnLayout.borderRightWidth,
  } as CSSProperties;
};
